import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Badge,
  Container,
  Row,
  Col,
  Alert,
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamationTriangle,
  faUser,
  faEnvelope,
  faCheck,
  faTimes,
  faCommentDots,
} from '@fortawesome/free-solid-svg-icons'
import { getAppeals } from 'store/Recruitment/actions'
import AxiosInstance from 'utils/AxiosInstance'
import { updateInterview } from 'store/Recruitment/actions'

function Appeals({ jobId }) {
  const dispatch = useDispatch()
  const { appeals } = useSelector((store) => store.recruitment)
  const [processingAppeals, setProcessingAppeals] = useState(new Set())

  useEffect(() => {
    if (jobId) {
      dispatch(getAppeals(jobId))
    }
  }, [dispatch, jobId])

  const handleApproveAppeal = async (appealId) => {
    setProcessingAppeals((prev) => new Set([...prev, appealId]))

    try {
      dispatch(
        updateInterview(appealId, {
          took_interview: 0,
          exited_interview: 0,
          appeal: null,
        })
      )
      // Refresh the appeals list after approval
      dispatch(getAppeals(jobId))
    } catch (error) {
      console.error('Failed to approve appeal:', error)
      alert('Failed to approve appeal. Please try again.')
    } finally {
      setProcessingAppeals((prev) => {
        const newSet = new Set(prev)
        newSet.delete(appealId)
        return newSet
      })
    }
  }

  if (!appeals || appeals.length === 0) {
    return (
      <Container className='mt-4'>
        <Alert color='info' className='text-center'>
          <FontAwesomeIcon icon={faCommentDots} className='mr-2' />
          No appeals have been submitted for this job position yet.
        </Alert>
      </Container>
    )
  }

  return (
    <Container className='mt-4'>
      <Row>
        {appeals.map((appeal) => (
          <Col lg={6} xl={4} key={appeal.id} className='mb-4'>
            <Card className='h-100 shadow-sm border-0'>
              <CardHeader className='bg-gradient-primary text-white'>
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='d-flex align-items-center'>
                    <FontAwesomeIcon icon={faUser} className='mr-2' />
                    <h6 className='mb-0 text-white'>{appeal.name}</h6>
                  </div>
                </div>
              </CardHeader>

              <CardBody className='d-flex flex-column'>
                <div className='mb-3'>
                  <div className='d-flex align-items-center text-muted mb-2'>
                    <FontAwesomeIcon icon={faEnvelope} className='mr-2' />
                    <small>{appeal.email}</small>
                  </div>
                  <div className='d-flex align-items-start mb-2'>
                    <FontAwesomeIcon
                      icon={faCommentDots}
                      className='mr-2 mt-1 text-primary'
                    />
                    <small className='text-muted'>Appeal Message:</small>
                  </div>
                  <div
                    className='border-left border-primary pl-3 py-2 bg-light rounded-right'
                    style={{ borderLeftWidth: '4px' }}
                  >
                    <p className='mb-0 text-dark'>"{appeal.appeal}"</p>
                  </div>
                </div>

                <div className='mt-auto'>
                  <div
                    className='d-flex justify-content-between'
                    style={{ gap: '0.5rem' }}
                  >
                    <Button
                      color='success'
                      size='sm'
                      onClick={() => handleApproveAppeal(appeal.id)}
                      disabled={processingAppeals.has(appeal.id)}
                      className='flex-fill'
                    >
                      {processingAppeals.has(appeal.id) ? (
                        <>
                          <span className='spinner-border spinner-border-sm mr-1'></span>
                          Processing...
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faCheck} className='mr-1' />
                          Approve
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default Appeals
